import React, { useState } from 'react'
import ReactModal from 'react-modal'
import '../../styles/modals/FeedBackModal.css'
import { ReactComponent as CloseModalIcon } from '../../assets/svg/CloseModalIcon.svg'
import { useTranslation } from 'react-i18next'
import { notify } from '../../utils/util'
import { takeActionFeedbackComment } from '../../server/server'
import TextareaAutosize from 'react-textarea-autosize'
import { Toaster } from 'react-hot-toast'
import Loading from '../Loading'
import { MultipleEmotionsHeader, SingleEmotionHeader } from './WellBeingAsignModal'

function WellBeingTakeActionModal({ modalIsOpen, closeModal, student, note, assignMessage = '', multipleEmotions = false, isAlert = false }) {
    const { t, locale } = useTranslation()
    const [message, setMessage] = useState(assignMessage)
    const [processing, setProcessing] = useState(false)

    const assignAction = async () => {
        if (message == '') {
            notify(t('youMustFillData'))
            return
        }
        let data = {
            user_message: message,
        }
        if (note?.feedback_id && !multipleEmotions) data['feedback_id'] = note.feedback_id
        else if (isAlert) {
            if (multipleEmotions) data['alert_id'] = note.id
            else data['feedback_id'] = note?.id
        } else data['student_id'] = student?.id
        setProcessing(true)
        const resp = await takeActionFeedbackComment(data)
        if (resp.status === 200) {
            notify(t('Action taken'))
            closeModal(true)
        } else {
            notify(t('assignActionFailed'))
        }
        setProcessing(false)
    }

    React.useEffect(() => {
        if (modalIsOpen) {
            ReactModal.setAppElement('#root')
            document.getElementById('home').style.filter = 'blur(5px)'
            if (assignMessage) setMessage(assignMessage)
        } else {
            document.getElementById('home').style.filter = 'unset'
        }
    }, [modalIsOpen])

    return (
        <ReactModal
            // ariaHideApp={false}
            transparent
            closeTimeoutMS={600}
            isOpen={modalIsOpen}
            onAfterOpen={() => {}}
            onAfterClose={() => {
                setMessage('')
            }}
            onRequestClose={closeModal}
            style={{
                overlay: {
                    zIndex: 30,
                    overflowY: 'scroll',
                    height: '100vh',
                },
                content: {
                    padding: 0,
                    margin: 'auto',
                    opacity: 1,
                    width: 600,
                    backgroundColor: 'transparent',
                    border: 'none',
                    borderRadius: 10,
                    boxShadow: 'none',
                    overflow: 'hidden',
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingBottom: 30,
                    alignSelf: 'center',
                },
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignSelf: 'center',
                }}
            >
                <div className="feedback-modal-icon" onClick={() => closeModal()}>
                    <CloseModalIcon />
                </div>
            </div>
            <div className="feedback-student-modal">
                {!multipleEmotions && <SingleEmotionHeader student={student} note={note} />}
                {multipleEmotions && <MultipleEmotionsHeader student={student} note={note} />}
                {/* background: #fafaff; */}
                <div className="rounded-[10px] py-5 px-[30px]  bg-whiteContrast ">
                    {!!note?.message && (
                        <div className="feedback-modal-messege-body">
                            <p>{t('comment')} </p>
                            <span>{note.message}</span>
                        </div>
                    )}

                    <div className="flex flex-col mt-6  ">
                        <p className="text-[#5E639B] font-semibold text-[18px] leading-[22px]">{t('Take action')}</p>
                        <div className={`feedback-assigned-multiline !mt-[20px]`}>
                            <div className="feedback-textarea">
                                <TextareaAutosize
                                    placeholder={t('Write your personal notes here')}
                                    id="action-message-textarea"
                                    minRows={6}
                                    value={message}
                                    style={{ resize: 'none' }}
                                    autoFocus
                                    onChange={(e) => {
                                        e.preventDefault()
                                        setMessage(e.target.value)
                                    }}
                                />
                            </div>
                            <button className="textarea-button" id="text-area-button" onClick={() => assignAction()} disabled={processing}>
                                {processing ? <Loading /> : <p>{t('submit')} </p>}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* <Toaster position="top-right" reverseOrder={false} toastOptions={{ duration: 3000 }} /> */}
        </ReactModal>
    )
}

export default WellBeingTakeActionModal
